//
import { RDashboardLayout } from "@/components/reusable_components/layouts"

//
import routes from "./routes"

//
export default [
    {
        path        : "/", 
        component   : RDashboardLayout, 
        children    : routes,
    },
]